import { Scalars } from 'src/generated/graphql';
import { CardsMarketplaceOfferAO } from 'src/lib/approval-odds/types';

export type QuizResponse = {
  offers: QuizOffer[];
};

export type CardsMarketplaceInstitution = {
  details?: CardsMarketplaceInstitutionDetails | null;
  id: string;
  name: string;
};

export type CardsMarketplaceInstitutionDetails = {
  enable_match_score_display?: boolean | null;
  manual_entry?: boolean | null;
};

export type CardsMarketplaceOffer = {
  derived_details: CardsMarketplaceOfferDerivedDetails;
  details: CardsMarketplaceOfferDetails;
  id: string;
  name: string;
  product: CardsMarketplaceProduct;
  status: CardsMarketplaceStatus;
};

export type CardsMarketplaceProduct = {
  details?: CardsMarketplaceProductDetails | null;
  id: string;
  institution: CardsMarketplaceInstitution;
  name: string;
};

export type CardsMarketplaceProductDetails = {
  manual_entry?: boolean | null;
};

export type ItemizedScore = {
  availablePoints?: number | null;
  awardedPoints?: number | null;
  name: string;
};

export type QuizOffer = {
  itemizedMethodology?: ItemizedScore[] | null;
  itemizedScore?: ItemizedScore[] | null;
  matchScore: number;
  offer: CardsMarketplaceOfferAO;
  approvalOdds?: string;
};

export enum CardsMarketplaceOfferPromosType {
  Cash = 'CASH',
  Points = 'POINTS',
  Miles = 'MILES',
  NoRewards = 'NO REWARDS',
}

export enum CardsMarketplaceStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
}

/*
##############################################################
#####  GENERATED MARKETPLACE TYPES, DO NOT MANUALLY EDIT #####
##############################################################
*/
export type CardsMarketplaceOfferDetails = {
  annual_fee: number;
  annual_fee_details?: string | null;
  best_of_badge_winner_2020?:
    | CardsMarketplaceOfferBestOfBadgeWinner2020[]
    | null;
  best_of_badge_winner_2021?:
    | CardsMarketplaceOfferBestOfBadgeWinner2021[]
    | null;
  reward_program_name?: string | null;
  annual_fee_first_year: number;
  apply_pay_per_call?: string | null;
  apr_average?: number | null;
  apr_display_list: string[];
  apr_excellent?: number | null;
  apr_good?: number | null;
  apr_intro_message?: string | null;
  apr_intro_message_list: string[];
  apr_max?: number | null;
  apr_min?: number | null;
  apr_poor?: number | null;
  balance_transfer_fee?: number | null;
  balance_transfer_intro_apr?: number | null;
  balance_transfer_fee_description?: string | null;
  balance_transfer_intro_fee_description?: string | null;
  balance_transfer_intro_time?: number | null;
  banned_pages?: string[] | null;
  billing_cycle_units: string;
  canonical_url?: string | null;
  card_categories?: string[] | null;
  card_user?: CardsMarketplaceOfferCardUser | null;
  cash_advance_apr?: number | null;
  cash_advance_fee?: number | null;
  cobrand_airline?: CardsMarketplaceOfferCobrandAirline | null;
  cobrand_hotel?: CardsMarketplaceOfferCobrandHotel | null;
  compare_categories?: CardsMarketplaceOfferCompareCategories[] | null;
  cons_bullets?: string[] | null;
  content_tips?: string[] | null;
  custom_details_list?: string[] | null;
  disclaimer?: string | null;
  disclaimer_text?: string | null;
  editorial_value_prop?: string | null;
  feed_id?: number | null;
  feed_product_id?: string | null;
  foreign_transaction_fee: number;
  foreign_transaction_fee_description?: string | null;
  image_alt_text: string;
  image_is_portrait: boolean;
  image_source: string;
  image_source_large: string;
  image_source_medium: string;
  included_pages?: string[] | null;
  is_editorial_apply_link_disabled?: boolean | null;
  is_fixed_rate: boolean;
  is_monetizing?: boolean | null;
  is_shown_on_tool: boolean;
  issuer_info_page_url?: string | null;
  last_ingested_at?: number | null;
  late_payment_fee?: number | null;
  late_payment_fee_description?: string | null;
  legacy_id: number;
  manual_entry?: boolean | null;
  marketing_bullets?: string[] | null;
  marketing_bullets_without_terms_and_fees_link?: string[] | null;
  max_fico: number;
  meta_description?: string | null;
  meta_keywords?: string[] | null;
  meta_title?: string | null;
  min_fico: number;
  minimum_deposit?: number | null;
  minimum_deposit_description?: string | null;
  obsolete_referrals?: number[] | null;
  offer_url?: string | null;
  ongoing_apr: string;
  ongoing_apr_annotated?: string | null;
  ongoing_apr_unannotated: string;
  penalty_apr?: number | null;
  perks?: CardsMarketplaceOfferPerks[] | null;
  prequal_link?: string | null;
  prequal_link_text?: string | null;
  processing_network?: CardsMarketplaceOfferProcessingNetwork | null;
  pros_bullets?: string[] | null;
  purchase_apr?: string | null;
  purchase_apr_annotated?: string | null;
  purchase_intro_apr?: number | null;
  purchase_intro_time?: number | null;
  rating_stars?: number | null;
  related_card_ids?: number[] | null;
  related_content?: string[] | null;
  reward_categories_best_rates?:
    | CardsMarketplaceOfferRewardCategoriesBestRates[]
    | null;
  reward_type?: string | null;
  reward_rate: number;
  reward_rate_details: string;
  reward_rate_notes?: string | null;
  redemption_complexity?: number | null;
  seo_name?: string | null;
  redemptions?: CardsMarketplaceOfferRedemptions[] | null;
  review_link?: string | null;
  sign_up_bonus: number;
  sign_up_bonus_details: string;
  sign_up_bonus_details_annotation: string;
  sign_up_bonus_type?: CardsMarketplaceOfferSignUpBonusType | null;
  slug?: string | null;
  terms_and_fees_link?: string | null;
  promos?: CardsMarketplaceOfferPromos[] | null;
  rewards?: CardsMarketplaceOfferRewards[] | null;
  rewards_rates: Array<CardsMarketplaceOfferRewardsRates>;
  best_of_awards?: CardsMarketplaceOfferBestOfAwards[] | null;
  limited_credit_history?: boolean | null;
};

export type CardsMarketplaceOfferDerivedDetails = {
  apply_link?: string | null;
  approval_likelihood?: number | null;
  balance_transfer_cfa?: number | null;
  balance_transfer_interest_savings?: number | null;
  category_dining?: number | null;
  category_gas?: number | null;
  category_grocery_drug?: number | null;
  category_office?: number | null;
  category_other?: number | null;
  category_travel?: number | null;
  debt_free_monthly_payment?: number | null;
  estimated_ongoing_apr?: number | null;
  fees?: number | null;
  is_approval_likely?: boolean | null;
  is_sponsored?: boolean | null;
  match_score?: number | null;
  monetizable?: CardsMarketplaceOfferMonetizable | null;
  net_rewards?: number | null;
  reward_cents_per_unit?: number | null;
  reward_cents_per_unit_string?: string | null;
  purchase_cfa?: number | null;
  purchase_interest_savings?: number | null;
  sign_up_bonus?: number | null;
  spending_rewards?: number | null;
  terms_and_fees_redirect_link?: string | null;
  total_balance_transfer_cost?: number | null;
  total_balance_transfer_savings_ongoing_interest?: number | null;
  total_balance_transfer_savings_time?: number | null;
  total_purchase_savings_amount?: number | null;
  total_purchase_savings_ongoing_interest?: number | null;
  total_purchase_savings_time?: number | null;
  total_savings_amount?: number | null;
  true_balance_transfer_cost?: number | null;
  true_interest_cost?: number | null;
  visitor_approval_likelihood?: number | null;
};

export type CardsMarketplaceOfferRewardCategoriesBestRates = {
  rate: number;
  category: CardsMarketplaceOfferRewardCategoriesBestRatesCategory;
};

export type CardsMarketplaceOfferPromos = {
  id: string | null;
  type: CardsMarketplaceOfferPromosType | null;
  version_id: number | null;
  spend_amount: number | null;
  spend_months: number | null;
  reward_amount: number | null;
  display_suffix: string | null;
};

export type CardsMarketplaceOfferRewards = {
  id: string | null;
  cap: number | null;
  rate: number;
  period: CardsMarketplaceOfferRewardsPeriod;
  category: CardsMarketplaceOfferRewardsCategory;
  duration: number;
  is_custom: boolean | null;
  is_rotating: boolean | null;
  is_tiered: boolean;
  recommendation_category: CardsMarketplaceOfferRewardsRecommendationCategory | null;
  version_id: number;
};

export type CardsMarketplaceOfferBestOfAwards = {
  year: string | null;
  category: CardsMarketplaceOfferBestOfAwardsCategory | null;
};

export enum CardsMarketplaceOfferMonetizable {
  YesAssumed = 'yes_assumed',
  No = 'no',
  NoBecauseOfLimit = 'no_because_of_limit',
}

export enum CardsMarketplaceOfferBestOfBadgeWinner2020 {
  Best0IntroAprCreditCard = 'Best 0% Intro APR Credit Card',
  BestAirlineCreditCard = 'Best Airline Credit Card',
  BestBalanceTransferCreditCard = 'Best Balance-Transfer Credit Card',
  BestBonusRewardsCashBackCreditCard = 'Best Bonus Rewards Cash-Back Credit Card',
  BestBonusRewardsTravelCreditCard = 'Best Bonus Rewards Travel Credit Card',
  BestCreditCardForBuildingCredit = 'Best Credit Card for Building Credit',
  BestCreditCardForCollegeStudents = 'Best Credit Card for College Students',
  BestCreditCardForDiningAndEntertainment = 'Best Credit Card for Dining and Entertainment',
  BestCreditCardForFairCredit = 'Best Credit Card for Fair Credit',
  BestCreditCardForFamilies = 'Best Credit Card for Families',
  BestCreditCardForInternationalStudents = 'Best Credit Card for International Students',
  BestFlatRateCashBackCreditCard = 'Best Flat-Rate Cash-Back Credit Card',
  BestFlatRateTravelCreditCard = 'Best Flat-Rate Travel Credit Card',
  BestGasCreditCard = 'Best Gas Credit Card',
  BestHotelCreditCard = 'Best Hotel Credit Card',
  BestNoAnnualFeeTravelCreditCard = 'Best No-Annual-Fee Travel Credit Card',
  BestPremiumCreditCard = 'Best Premium Credit Card',
  BestSmallBusinessCashBackCreditCard = 'Best Small-Business Cash-Back Credit Card',
  BestSmallBusinessTravelCreditCard = 'Best Small-Business Travel Credit Card',
  BestStoreCreditCard = 'Best Store Credit Card',
}

export enum CardsMarketplaceOfferBestOfBadgeWinner2021 {
  Best0IntroAprAndBalanceTransferCreditCard = 'Best 0% Intro APR and Balance Transfer Credit Card',
  BestAirlineCreditCard = 'Best Airline Credit Card',
  BestBonusRewardsCashBackCreditCard = 'Best Bonus Rewards Cash-Back Credit Card',
  BestBonusRewardsTravelCreditCard = 'Best Bonus Rewards Travel Credit Card',
  BestCreditCardForBuildingCredit = 'Best Credit Card for Building Credit',
  BestCreditCardForCollegeStudents = 'Best Credit Card for College Students',
  BestCreditCardForDiningOutOrOrderingIn = 'Best Credit Card for Dining Out or Ordering In',
  BestCreditCardForGroceries = 'Best Credit Card for Groceries',
  BestCreditCardForStayingAtHome = 'Best Credit Card for Staying at Home',
  BestFlatRateCashBackCreditCard = 'Best Flat-Rate Cash-Back Credit Card',
  BestFlatRateTravelCreditCard = 'Best Flat-Rate Travel Credit Card',
  BestHotelCreditCard = 'Best Hotel Credit Card',
  BestNoAnnualFeeTravelCreditCard = 'Best No-Annual-Fee Travel Credit Card',
  BestSmallBusinessCashBackCreditCard = 'Best Small-Business Cash-Back Credit Card',
}

export enum CardsMarketplaceOfferCardUser {
  Business = 'business',
  Personal = 'personal',
  Student = 'student',
}

export type CardsMarketplaceOfferCobrandAirline =
  | 'AEROPLAN'
  | 'AIR_LINGUS'
  | 'ALASKA_AIRLINES'
  | 'AMERICAN_AIRLINES'
  | 'BRITISH_AIRWAYS'
  | 'DELTA'
  | 'IBERIA'
  | 'JETBLUE'
  | 'OTHER'
  | 'SOUTHWEST_AIRLINES'
  | 'UNITED_AIRLINES';

export type CardsMarketplaceOfferCobrandHotel =
  | 'HILTON'
  | 'HYATT'
  | 'IHG'
  | 'MARRIOTT'
  | 'OTHER'
  | 'RADISSON'
  | 'WYNDHA';

export enum CardsMarketplaceOfferCompareCategories {
  AirlineCreditCards = 'airline-credit-cards',
  BadCreditCards = 'bad-credit-cards',
  BalanceTransferCreditCards = 'balance-transfer-credit-cards',
  BusinessCreditCards = 'business-credit-cards',
  CashRewardsCreditCards = 'cash-rewards-credit-cards',
  CreditCardBonusOffers = 'credit-card-bonus-offers',
  GasCreditCards = 'gas-credit-cards',
  HotelCreditCards = 'hotel-credit-cards',
  LowInterestCreditCards = 'low-interest-credit-cards',
  NwSearch = 'nw-search',
  PersRecResults = 'pers-rec-results',
  RecommendedPlacement = 'recommended_placement',
  RewardsCreditCards = 'rewards-credit-cards',
  SecuredCreditCards = 'secured-credit-cards',
  ShadowCard = 'shadow-card',
  StudentCreditCards = 'student-credit-cards',
  TheBestCreditCards = 'the-best-credit-cards',
  TravelMilesCreditCards = 'travel-miles-credit-cards',
  ZeroPercentCreditCards = 'zero-percent-credit-cards',
  CardfinderExcluded = 'cardfinder-excluded',
}

export enum CardsMarketplaceOfferPerks {
  HasCompanionFareAnnualFlight = 'has-companion-fare-annual-flight',
  HasFreeAnnualHotelNight = 'has-free-annual-hotel-night',
  HasFreeCheckedBags = 'has-free-checked-bags',
  HasAirportLoungeAccess = 'has-airport-lounge-access',
  HasGlobalentryTsaCredit = 'has-globalentry-tsa-credit',
  HasPrimaryRentalCarInsurance = 'has-primary-rental-car-insurance',
  HasTravelCredits = 'has-travel-credits',
  HasAutomaticEliteStatus = 'has-automatic-elite-status',
}

export enum CardsMarketplaceOfferProcessingNetwork {
  AmericanExpress = 'american_express',
  Discover = 'discover',
  Mastercard = 'mastercard',
  Visa = 'visa',
}

export enum CardsMarketplaceOfferRedemptions {
  RedeemForAmericanAirlines = 'redeem-for-american-airlines',
  RedeemForUnitedAirlines = 'redeem-for-united-airlines',
  RedeemForDeltaAirlines = 'redeem-for-delta-airlines',
  RedeemForSouthwestAirlines = 'redeem-for-southwest-airlines',
  RedeemForAlaskaAirlines = 'redeem-for-alaska-airlines',
  RedeemForMarriottStarwoodHotel = 'redeem-for-marriott-starwood-hotel',
  RedeemForHiltonHotel = 'redeem-for-hilton-hotel',
  RedeemForHyattHotel = 'redeem-for-hyatt-hotel',
  RedeemForMutlipleAirlinesHotels = 'redeem-for-mutliple-airlines-hotels',
  RedeemForMultipleAirlinesHotels = 'redeem-for-multiple-airlines-hotels',
  RedeemForStatementCredit = 'redeem-for-statement-credit',
}

export enum CardsMarketplaceOfferSignUpBonusType {
  Cash = 'CASH',
  Points = 'POINTS',
  Miles = 'MILES',
  NoRewards = 'NO REWARDS',
}

export enum CardsMarketplaceOfferRewardCategoriesBestRatesCategory {
  Airfare = 'airfare',
  All = 'all',
  Bookstores = 'bookstores',
  Business = 'business',
  CarRental = 'car rental',
  Charity = 'charity',
  Dining = 'dining',
  Discount = 'discount',
  Drugstores = 'drugstores',
  Entertainment = 'entertainment',
  Gas = 'gas',
  Groceries = 'groceries',
  HomeImprove = 'home improve',
  Hotel = 'hotel',
  Lodging = 'lodging',
  Movies = 'movies',
  Office = 'office',
  Other = 'other',
  Parking = 'parking',
  Playstation = 'playstation',
  Telecom = 'telecom',
  Travel = 'travel',
  Utilities = 'utilities',
  Wireless = 'wireless',
}

export enum CardsMarketplaceOfferRewardsPeriod {
  FirstYear = 'first year',
  Monthly = 'monthly',
  Quarterly = 'quarterly',
  Yearly = 'yearly',
}

export type CardsMarketplaceOfferRewardsRates = {
  description: string;
  rate: Scalars['Float'];
};

export enum CardsMarketplaceOfferRewardsCategory {
  Airfare = 'airfare',
  All = 'all',
  Bookstores = 'bookstores',
  Business = 'business',
  CarRental = 'car rental',
  Charity = 'charity',
  Dining = 'dining',
  Discount = 'discount',
  Drugstores = 'drugstores',
  Entertainment = 'entertainment',
  Gas = 'gas',
  Groceries = 'groceries',
  HomeImprove = 'home improve',
  Hotel = 'hotel',
  Lodging = 'lodging',
  Movies = 'movies',
  Office = 'office',
  Other = 'other',
  Parking = 'parking',
  Playstation = 'playstation',
  Telecom = 'telecom',
  Travel = 'travel',
  Utilities = 'utilities',
  Wireless = 'wireless',
}

export enum CardsMarketplaceOfferRewardsRecommendationCategory {
  All = 'ALL',
  DrugStores = 'DRUG_STORES',
  Entertainment = 'ENTERTAINMENT',
  Gas = 'GAS',
  Groceries = 'GROCERIES',
  HomeImprovement = 'HOME_IMPROVEMENT',
  OnlineShopping = 'ONLINE_SHOPPING',
  Restaurants = 'RESTAURANTS',
  Streaming = 'STREAMING',
  Travel = 'TRAVEL',
}

export enum CardsMarketplaceOfferBestOfAwardsCategory {
  Best0AprCreditCardForPurchases = 'Best 0% APR Credit Card for Purchases',
  Best0IntroAprAndBalanceTransferCreditCard = 'Best 0% Intro APR and Balance Transfer Credit Card',
  BestAirlineCreditCard = 'Best Airline Credit Card',
  BestAllPurposeTravelRewardsCreditCard = 'Best All-Purpose Travel Rewards Credit Card',
  BestBalanceTransferCreditCard = 'Best Balance Transfer Credit Card',
  BestBasicTravelRewardsCreditCard = 'Best Basic Travel Rewards Credit Card',
  BestCreditCardForBonusCashBack = 'Best Credit Card for Bonus Cash Back',
  BestCreditCardForBuildingCredit = 'Best Credit Card for Building Credit',
  BestCreditCardForCollegeStudents = 'Best Credit Card for College Students',
  BestCreditCardForDining = 'Best Credit Card for Dining',
  BestCreditCardForEntertainment = 'Best Credit Card for Entertainment',
  BestCreditCardForGas = 'Best Credit Card for Gas',
  BestCreditCardForGroceries = 'Best Credit Card for Groceries',
  BestCreditCardForSimpleCashBack = 'Best Credit Card for Simple Cash Back',
  BestCreditCardForTravelPerks = 'Best Credit Card for Travel Perks',
  BestHotelCreditCard = 'Best Hotel Credit Card',
  BestPremiumTravelCreditCard = 'Best Premium Travel Credit Card',
  BestSmallBusinessCreditCard = 'Best Small-Business Credit Card',
}
